import { FC } from 'react';

import { MailIcon } from '@heroicons/react/outline';

interface ContactEmailLinkProps {
  className?: string;
}

export const ContactEmailLink: FC<ContactEmailLinkProps> = ({ className = 'mt-6' }) => {
  return (
    <div className={`text-center ${className}`}>
      <a
        href="mailto:smartnanumi@kakao.com"
        className="inline-flex items-center gap-1 text-xs text-stone-500 transition hover:text-stone-600"
      >
        <MailIcon className="h-3 w-3" />
        <span>문의 smartnanumi@kakao.com</span>
      </a>
    </div>
  );
};
